import axios from 'axios';
import {EventBus} from '@/event-bus.js';

let pendingRequests = [];

/**
 * Hold requests rejected because Jaama expired the user's token, ask the session timeout modal to
 * re-authenticate, then replay the held requests so the calling component carries on as normal
 */
export const installSessionTimeoutInterceptor = () => {
  axios.interceptors.response.use(response => response, error => {
    const reauthenticate = error.response?.status === 401 ? error.response.data?.reauthenticate : null;

    if (!reauthenticate || !error.config) {
      return Promise.reject(error);
    }

    return new Promise((resolve, reject) => {
      pendingRequests.push({config: error.config, resolve, reject});

      if (pendingRequests.length === 1) {
        EventBus.$emit('session-timeout', reauthenticate);
      }
    });
  });

  EventBus.$on('session-reauthenticated', () => {
    const requests = pendingRequests;
    pendingRequests = [];

    requests.forEach(({config, resolve, reject}) => {
      axios(config).then(resolve, reject);
    });
  });
};
